export const setPurchasingItem = (state, itemToPurchase) => {
  state.purchasingItem = itemToPurchase;
};
